import { useQuery } from "@tanstack/react-query";


import { getProjectMembers } from "../api/getProjectMembers";

export const useProjectMembers   = (orgUuid?: string) =>
  useQuery({
    queryKey: ["project-members", orgUuid],
    queryFn: () => {
      if (!orgUuid) {
        throw new Error("Missing Ord Id");
      }
      return getProjectMembers(orgUuid);
    },
    enabled: Boolean(orgUuid), // 🔥 prevents premature call
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
